<div
  class="loren-asset-details-map-container"
  [style.height]="mapFullSize() ? '389px' : '51px'">
  <div
    #mapWrapper
    leaflet
    class="loren-asset-details-map"
    [ngClass]="{ 'loren-asset-details-map-minimised': !mapFullSize() }"
    [style.width]="'100%'"
    [style.height]="'100%'"
    [leafletOptions]="options"
    (leafletMapReady)="onMapReady($event)"></div>
    <button
            matButton="filled"
            class="loren-asset-details-map-minimise btn-secondary"
            (click)="toggleMapFullSize()">
        @if (!mapFullSize()) {
            <mat-icon>remove_red_eye</mat-icon>
        }
        {{
            (mapFullSize() ? "home.minimise_map" : "home.show_full_map") | transloco
        }}
    </button>
  @if(mapFullSize()) {
      <button
              matButton="filled"
              class="loren-asset-details-map-zoom-reset btn-secondary"
              (click)="centerMarker()">
          <mat-icon>zoom_out_map</mat-icon>
      </button>
  }
</div>
